import React from 'react';
import { motion } from 'framer-motion';
import { Logo } from '../ui/Logo';
import { Mail, Globe, ArrowRight } from 'lucide-react';
export function ContactSlide() {
  return <div className="w-full h-full bg-bg-dark text-white flex flex-col items-center justify-center relative overflow-hidden" data-id="element-128">
      {/* Background Elements */}
      <div className="absolute inset-0 overflow-hidden" data-id="element-129">
        <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-primary-light/20 via-bg-dark to-bg-dark" data-id="element-130" />
      </div>

      <div className="relative z-10 flex flex-col items-center text-center max-w-4xl px-6" data-id="element-131">
        <motion.div initial={{
        scale: 0.8,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} transition={{
        duration: 0.8
      }} className="mb-12" data-id="element-132">
          <Logo variant="light" size="xl" className="justify-center" data-id="element-133" />
        </motion.div>

        <motion.h2 className="text-3xl md:text-5xl font-bold mb-6 leading-tight" initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: 0.3
      }} data-id="element-134">
          Lassen Sie uns Ihre Prozesse <br data-id="element-135" />
          <span className="text-accent" data-id="element-136">digital denken.</span>
        </motion.h2>

        <motion.p className="text-xl text-gray-300 mb-12" initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: 0.5
      }} data-id="element-137">
          Wir freuen uns auf Ihr Projekt.
        </motion.p>

        <motion.a href="https://calendly.com/intigoo/erstgespraech" target="_blank" rel="noopener noreferrer" className="group bg-accent hover:bg-accent-dark text-white font-bold py-4 px-10 rounded-full text-lg transition-all duration-300 flex items-center gap-3 shadow-lg hover:shadow-accent/20 hover:scale-105" initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: 0.7
      }} whileTap={{
        scale: 0.95
      }} data-id="element-138">
          Gespräch vereinbaren
          <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-139" />
        </motion.a>

        <motion.div className="mt-16 flex flex-col md:flex-row gap-8 text-gray-400" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1
      }} data-id="element-140">
          <div className="flex items-center gap-3 hover:text-white transition-colors" data-id="element-141">
            <Mail className="w-5 h-5" data-id="element-142" />
            <span data-id="element-143">info@intigoo.de</span>
          </div>
          <div className="flex items-center gap-3 hover:text-white transition-colors" data-id="element-144">
            <Globe className="w-5 h-5" data-id="element-145" />
            <span data-id="element-146">www.intigoo.de</span>
          </div>
        </motion.div>
      </div>
    </div>;
}